/**
 * 短信网配置
 */

import { SqlitePageConfigurationPublicGetPaged } from "@/api/Sqlite";
import globalConfig from "../../public/globalConfigFriendly.json";

/**
 * 获取当前平台短信网发送配置
 * @param {*} tenantId
 */
export async function getCurrentPlatformSmSConfig(tenantId) {
  if (!tenantId) throw new Error("缺少tenantId参数");
  // 获取平台配置数据
  const { result } = await SqlitePageConfigurationPublicGetPaged({
    filter: `tenantId == "${tenantId}" && templateId == "${globalConfig.setting.templateId.platformConfig}"`,
  });
  const platformConfigItem = JSON.parse(result.items[0].content);
  // 获取验证码模板
  const VERIFICATION_CODE_TEMPLATE =
    platformConfigItem.messageTemplateIdBind.find(
      (v) => v.templateKey === "VERIFICATION_CODE_TEMPLATE"
    ).templateID;
  if (
    !(
      VERIFICATION_CODE_TEMPLATE &&
      platformConfigItem.messageConfigName &&
      platformConfigItem.signId
    )
  ) {
    throw new Error("缺少验证码短信模板配置");
  }
  const res = {
    smsConfigName: platformConfigItem.messageConfigName,
    signId: platformConfigItem.signId, // 短信签名
    templateId: VERIFICATION_CODE_TEMPLATE, // 验证码模板templateId
  };
  return res;
}
